import React from 'react'
import styled from '@emotion/styled'
import { Link } from 'gatsby'
import { formatTitle } from 'utils/conversions'

var slugify = require('slugify')

const Main = styled.div`
	align-items: flex-start;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  max-width: 100%;
`

const TabContainer = styled.div`
  display: none;
  @media (min-width: 48rem) {
    display: block;
    max-width: 25%;
    flex-basis: 25%;
  }
`

const TabSection = styled.div`
  padding: 0rem;
  margin-bottom: 2.5rem;
`

const TabTitle = styled.div`
  color: rgb(177, 172, 163);
  position: relative;
  text-transform: uppercase;
  font-weight: 700 !important;
  font-size: 0.8rem !important;
  line-height: 1.5 !important;
  margin: 0px;
  margin-bottom: 0.5rem;
`

const Tab = styled.div`
	color: rgb(36, 30, 18);
  position: relative;
  font-weight: ${({selected}) => selected ? '700':'400'} !important;
  font-size: .9rem !important;
  line-height: 1.5 !important;
  margin: 0px;
  margin-bottom: 5px;
  a {
      text-decoration: none;
      color: rgb(36, 30, 18);
  }
`

const CopyContainer = styled.div`
    max-width: 100%; 
    width: 100%;   
    margin: 0 auto;
    @media (min-width: 48rem) {
      max-width: 75%;
      flex-basis: 75%;
      flex: 0 0 100%;
      padding: 0rem 0.5rem;
    }
`

 const CATEGORIES = [ 
  'commerce',
  'marketplace',
  'computer',
  'food',
  'social network',
  'browsing',
  'iot',
  'entertainment',
  'finance',
  'food/drink',
  'health/exercise',
  'automobile',
  'transportation',
  'delivery',
  'marketing intelligence',
  'real estate',
  'travel',
  'recreation',
  'advertising technology',
  'communications',
  'internet services',
  'credit',
  'political data',
  'events/ticketing',
  'hospitality',
  'transactions',
  'restaurants',
  'radio',
  'news',
  'directory',
  'facial recognition',
  'data enrichment',
  'location services',
  'analytics' ]

export default ({path, children}) => (
	<Main>
		<TabContainer>
        <TabSection>
          {console.log(path)}
            <TabTitle>Categories</TabTitle>
            {
                CATEGORIES.map((category)=>
                    <Tab selected={path.includes(slugify(category))}><Link to={`/categories/${slugify(category)}`}>{formatTitle(category)}</Link></Tab>
                )
            }
        </TabSection>
		</TabContainer>
		<CopyContainer>
      {children}
		</CopyContainer>
	</Main>
)











